__turbopack_context__.v({
  "offlineNotice": "C2C-FW_offlineNotice",
});
